import React, {useEffect, useState } from 'react'
import { Form, FloatingLabel } from "react-bootstrap"; //npm install react-bootstrap@next bootstrap@5.1.0

//import { Arr } from 'array-helpers'; //npm i array-helpers //https://www.npmjs.com/package/array-helpers

export default function SystemEditHospitalInputs(props) {

    const {hospitalPrices} = props;
    let prices = getPrices(hospitalPrices);

    const [formData, setFormData] = useState(defaultValueForm(prices))
    


    useEffect(() => {


        //console.log(formData);
        // וודא שתמיד נשלח גם price לתאימות אחורה
        const dataToSend = {
            ...formData,
            price: formData.price || formData.basePrice || ''
        };
        props.changePrices(dataToSend);
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData])

    //console.log(pricesShiftsArr);
    //console.log(prices);



    const handleChange = (e) => {
        
        const newFormData = {
            ...formData,
            [e.target.name]: e.target.value,
        };
        
        // אם basePrice השתנה, עדכן גם price (תאימות אחורה)
        if(e.target.name === 'basePrice') {
            newFormData.price = e.target.value;
            
            // חישוב אוטומטי של תעריפי שעות נוספות אם לא מוגדרים
            if(!newFormData.overtimeRate125 && e.target.value) {
                const basePriceNum = parseFloat(e.target.value);
                if(!isNaN(basePriceNum)) {
                    newFormData.overtimeRate125 = (basePriceNum * 1.25).toFixed(2);
                }
            }
            if(!newFormData.overtimeRate150 && e.target.value) {
                const basePriceNum = parseFloat(e.target.value);
                if(!isNaN(basePriceNum)) {
                    newFormData.overtimeRate150 = (basePriceNum * 1.50).toFixed(2);
                }
            }
        }
        
        setFormData(newFormData);
    }
    

    return (
        <div className='hospitalEditInputs'>

            <FloatingLabel label='שעת כניסה' className={!formData.timeStart || formData.timeStart === '00:00' ? 'empty' : ''}> 

                <Form.Control
                    className={"timeInput"}
                    //isInvalid={this.state.isError}
                    /*isValid={formik.touched.fullname && !formik.errors.fullname}  */
                    type="time"
                    name="timeStart"
                    onChange={handleChange}
                    value={formData.timeStart}
                />

            </FloatingLabel>

            <FloatingLabel label='שעת יציאה' className={!formData.timeEnd || formData.timeEnd === '00:00' ? 'empty' : ''}> 

                <Form.Control
                    className={"timeInput"}
                    //isInvalid={this.state.isError}
                    /*isValid={formik.touched.fullname && !formik.errors.fullname}  */
                    type="time"
                    name="timeEnd"
                    onChange={handleChange}
                    value={formData.timeEnd}
                />

            </FloatingLabel>

            <FloatingLabel label='תעריף בסיס' className={!formData.basePrice ? 'empty' : ''}> 

                <Form.Control
                  className={"price"}
                  type="number"
                  name="basePrice"
                  onChange={handleChange}
                  value={formData.basePrice}
                  step="0.01"
              />

            </FloatingLabel>

            <FloatingLabel label='תעריף 125% (שעות נוספות)' className={!formData.overtimeRate125 ? 'empty' : ''}> 

                <Form.Control
                  className={"price"}
                  type="number"
                  name="overtimeRate125"
                  onChange={handleChange}
                  value={formData.overtimeRate125}
                  placeholder="אופציונלי - יחושב אוטומטית"
                  step="0.01"
              />

            </FloatingLabel>

            <FloatingLabel label='תעריף 150% (שעות נוספות)' className={!formData.overtimeRate150 ? 'empty' : ''}> 

                <Form.Control
                  className={"price"}
                  type="number"
                  name="overtimeRate150"
                  onChange={handleChange}
                  value={formData.overtimeRate150}
                  placeholder="אופציונלי - יחושב אוטומטית"
                  step="0.01"
              />

            </FloatingLabel>

            <FloatingLabel label='הערות' className={!formData.notes ? 'empty' : ''}> 

                <Form.Control
                  as="textarea"
                  name="notes"
                  onChange={handleChange}
                  value={formData.notes}
                  rows={2}
              />

            </FloatingLabel>
        </div>
    )


}

function defaultValueForm(prices) {

    return {
        timeStart: prices.timeStart || '00:00',
        timeEnd: prices.timeEnd || '00:00',
        price: prices.price || prices.basePrice || '',
        basePrice: prices.basePrice || prices.price || '',
        overtimeRate125: prices.overtimeRate125 || '',
        overtimeRate150: prices.overtimeRate150 || '',
        notes: prices.notes || '',
        shiftName: prices.shiftName || '',
      }
    
}

function getPrices(hospitalPrices) {

    //const mainArray = new Arr(hospitalPrices);
    //const pricesShiftsArr = mainArray.multifilter('hospitalShiftId',hospitalShiftId);


    //console.log(hospitalPrices);

    let prices =  hospitalPrices;


    if(!prices) {

        prices = {
            timeStart: '00:00',
            timeEnd: '00:00',
            price: '',
            basePrice: '',
            overtimeRate125: '',
            overtimeRate150: '',
            notes: '',
            shiftName: ''
        }

    }

    return prices;
    
}
